import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../screens/Beranda.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Beranda',
  component: Home
}, ]

const router = new VueRouter({
  routes
})

export default router